import { RefObject, useState } from "react";

// Как в CSS: высота строки списка, его отступы и предел высоты.
const ITEM_HEIGHT = 36;
const LIST_PADDING = 12;
const MAX_HEIGHT = 240;
const GAP = 6 + 8;

// Список открываем вверх, чтобы не удлинять страницу,
// и вниз — только если сверху на экране он не помещается.
export const useOpenUp = (ref: RefObject<HTMLElement>, itemsCount: number) => {
  const [openUp, setOpenUp] = useState(true);

  const measure = () => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const height = Math.min(
      MAX_HEIGHT,
      itemsCount * ITEM_HEIGHT + LIST_PADDING,
    );
    setOpenUp(rect.top - GAP >= height);
  };

  return { openUp, measure };
};
